import * as cons from './constants';
import { requestReducerMaker, initialState } from '../helper'

export const getPaymentDetail = (state = initialState, action) => requestReducerMaker(cons.GET_PAYMENT_DETAIL, state, action);
export const payInvoiceByPaypal = (state = initialState, action) => requestReducerMaker(cons.PAY_INVOICE_BY_PAYPAL, state, action);